import { render, staticRenderFns } from "./productStatics.vue?vue&type=template&id=42a20a46&scoped=true"
import script from "./productStatics.vue?vue&type=script&lang=js"
export * from "./productStatics.vue?vue&type=script&lang=js"
import style0 from "./productStatics.vue?vue&type=style&index=0&id=42a20a46&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a20a46",
  null
  
)

export default component.exports